/**
 * @file Login — /login
 *
 * Role selector landing page.
 */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stethoscope, User } from "lucide-react";
import { useAuth } from "../hooks/useAuth";
import { APP_STRINGS } from "../constants/strings";
import AuthShell from "../components/AuthShell";

export default function Login() {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading || !isAuthenticated) return;
    if (user?.role === "PROFESIONAL" && user?.onboardingComplete === false) {
      navigate("/onboarding", { replace: true });
    } else if (user?.role === "PACIENTE") {
      navigate("/mi-salud", { replace: true });
    } else if (user?.role === "ADMIN") {
      navigate("/cx", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [isLoading, isAuthenticated, user, navigate]);

  return (
    <AuthShell title={APP_STRINGS.APP_NAME} subtitle="Selecciona cómo deseas ingresar">
      <button type="button" className="auth-role" onClick={() => navigate("/login/profesional")}>
        <span className="auth-role-icon">
          <Stethoscope size={22} />
        </span>
        <span className="auth-role-text">
          <span className="auth-role-title">Soy profesional de salud</span>
          <span className="auth-role-sub">Doctores, dentistas, psicólogos y más</span>
        </span>
      </button>
      <button type="button" className="auth-role" onClick={() => navigate("/login/paciente")}>
        <span className="auth-role-icon auth-role-icon-secondary">
          <User size={22} />
        </span>
        <span className="auth-role-text">
          <span className="auth-role-title">Soy paciente</span>
          <span className="auth-role-sub">Accede con tu correo electrónico</span>
        </span>
      </button>
    </AuthShell>
  );
}
